import React from "react";
import { Chart } from "primereact/chart";
import ChartDivider from "../../ChartDivider";
import ChartSkeleton from "../../../Skeletons/ChartSkeleton";
import DataAndQuantityType from "./DataAndQuantityType";
import ExperienceTable from "./ExperienceTable";
import { getExperienceSChartOptions } from "../../../../utils/chartOptions/dashboard/experiences";
import { toSentenceCase } from "../../../../utils/constants";
import ChartComponent from "../../brandScorecard/brandScorecardComponents/ChartComponent";
import NoChartData from "../../../sharedComponents/NoChartData";

const buttonOptions = [
  {
    name: "Top Box (%)",
    value: "Single",
    subTitle: "% of survey responses saying 'Disappointed'",
    headerSubTitle: true,
  },
  {
    name: "Mean Score (Avg)",
    value: "Mean",
    subTitle: "Average response - 3 point scale",
    headerSubTitle: false,
  },
  { name: "Full Data", value: "Full", subTitle: "", headerSubTitle: false },
];

const BrandPreference = React.memo(function BrandPreference(props) {
  const {
    activeDataTypeButton,
    setActiveDataTypeButton,
    brandPreferenceChartData,
    brandPreNeutralChartData,
    brandPreOkayChartData,
    chartQuestion,
    loading = false,
  } = props;
  // const maxDataValue = Math.max(
  //   ...(Array.isArray(props?.brandPreferenceChartData?.datasets) // Ensure datasets is an array
  //     ? props.brandPreferenceChartData.datasets.flatMap(
  //         (dataset) => (Array.isArray(dataset?.data) ? dataset.data : []), // Ensure dataset.data is an array
  //       )
  //     : [0]), // Default to [0] if datasets is undefined or not an array
  // );

  // const suggestedMax = Math.ceil(maxDataValue / 10) * 10 + 10; // Rounds up to nearest 10 and adds extra 10%

  // const options = {
  //   barThickness:
  //     props?.brandPreferenceChartData?.datasets === 1 ? 300 : undefined,
  //   indexAxis: "y", // Horizontal bar chart
  //   maintainAspectRatio: false,
  //   aspectRatio: 0.7,
  //   plugins: {
  //     legend: {
  //       display: true,
  //       position: "top",
  //       align: "start",
  //       labels: {
  //         padding: 15,
  //         font: { size: 12, weight: "bold" },
  //         color: "#6C757D",
  //       },
  //     },
  //     datalabels: {
  //       color: "#000",
  //       anchor: "end",
  //       align: "right",
  //       font: { weight: "bold", size: 12 },
  //       formatter: (value) => (value !== 0 ? value : ""),
  //     },
  //   },
  //   scales: {
  //     x: {
  //       stacked: false, // Stack the bars horizontally
  //       suggestedMax: suggestedMax,
  //       ticks: {
  //         font: { size: 12, weight: "bold" },
  //       },
  //     },
  //     y: {
  //       beginAtZero: true,
  //       ticks: {
  //         font: { size: 12, weight: "bold" },
  //       },
  //     },
  //   },
  // };

  const processTableLabel = () => {
    if (
      brandPreferenceChartData?.labels &&
      brandPreferenceChartData?.labels?.length
    ) {
      let tableDataVal = brandPreferenceChartData;
      let tableDataValLables = [
        "Total uses surveyed",
        ...tableDataVal?.labels,
        "Mean",
      ];
      tableDataVal.labels = tableDataValLables;
      return tableDataVal;
    } else {
      return brandPreferenceChartData;
    }
  };

  return (
    <div className="mt-4" style={{ maxWidth: "100%" }}>
      <div className="mb-4">
        {/* <DataAndQuantityType
          buttonOptions={buttonOptions}
          activeDataTypeButton={activeDataTypeButton}
          setActiveDataTypeButton={setActiveDataTypeButton}
          headerText={`Brand Preference`}
          headerSubTitle={
            buttonOptions.find(
              (option) => option.value === activeDataTypeButton,
            )?.headerSubTitle ? (
              <span>
                Base: XMOT<sup>&reg;</sup> Surveys
              </span>
            ) : (
              ""
            )
          }
          subTitle={
            buttonOptions.find(
              (option) => option.value === activeDataTypeButton,
            )?.subTitle
          }
        /> */}
        <div className="left-content">
          <h5 className="fw-bold text-start">{"Brand Preference"}</h5>
          {/* <h6 className="fw-bold text-start my-1">{headerSubTitle}</h6> */}
          <p
            className="mb-0 text-start fw-bold fs-12 py-1"
            style={{ color: "#6c757d" }}
          >
            % of survey responses
          </p>
        </div>
        {props?.chartQuestion ? (
          <>
            <div className="col-12">
              {/* {activeDataTypeButton === "Full" ? (
                <ExperienceTable
                  tableData={processTableLabel()}
                  question={chartQuestion}
                  loading={loading}
                />
              ) : (
                <>
                  {!props?.loading ? (
                    <Chart
                      redraw={(
                        props?.isFilterHide || props?.showSidebar
                      ).toString()}
                      type="bar"
                      data={props?.brandPreferenceChartData}
                      options={options}
                    />
                  ) : (
                    <ChartSkeleton />
                  )}
                </>
              )} */}

              <div className="row charts-section mt-3">
                <div className="col-md-4 col-sm-6 col-12 mb-3 px-1 frequency-chart">
                  <div className="chart-block p-2">
                    <div className="mb-3" style={{ width: "100%" }}>
                      {!props?.loading ? (
                        <ChartComponent
                          type="bar"
                          data={props?.brandPreferenceChartData}
                          options={getExperienceSChartOptions(
                            brandPreferenceChartData,
                            activeDataTypeButton,
                          )}
                          height={"400px"}
                        />
                      ) : (
                        <ChartSkeleton />
                      )}
                    </div>

                    <div className="tooltip-content py-1 px-2 text-center">
                      <div className="heading-text">{"Disappointed"}</div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-sm-6 col-12 mb-3 px-1 satisfaction-chart">
                  <div className="chart-block p-2">
                    <div className="mb-3" style={{ width: "100%" }}>
                      <ChartComponent
                        type="bar"
                        data={props?.brandPreNeutralChartData}
                        options={getExperienceSChartOptions(
                          brandPreNeutralChartData,
                          activeDataTypeButton,
                        )}
                        height={"400px"}
                      />
                    </div>

                    <div className="tooltip-content py-1 px-2 text-center">
                      <div className="heading-text">{"Neutral"}</div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-sm-6 col-12 mb-3 px-1 brand-preference-chart">
                  <div className="chart-block p-2">
                    <div className="mb-3" style={{ width: "100%" }}>
                      <ChartComponent
                        type="bar"
                        data={props?.brandPreOkayChartData}
                        options={getExperienceSChartOptions(
                          brandPreOkayChartData,
                          activeDataTypeButton,
                        )}
                        height={"400px"}
                      />
                    </div>

                    <div className="tooltip-content py-1 px-2 text-center">
                      <div className="heading-text">{"Okay"}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p
              style={{ width: "90%" }}
              className="p-2 fs-12 text-start rounded-2 fw-bold border text-secondary"
            >
              {toSentenceCase(props?.chartQuestion)}
            </p>
          </>
        ) : loading ? (
          <ChartSkeleton />
        ) : (
          <NoChartData
            msg={"No Data available to display in the chart at the moment."}
          />
        )}
        <ChartDivider />
      </div>
    </div>
  );
});

export default BrandPreference;
